import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
const EmailForms = () => {
  const [userEmail, setUserEmail] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [isSubmittingUser, setIsSubmittingUser] = useState(false);
  const [isSubmittingCompany, setIsSubmittingCompany] = useState(false);
  const {
    toast
  } = useToast();
  const handleUserSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmittingUser(true);
    try {
      const {
        error
      } = await supabase.from('beta_users').insert([{
        email: userEmail
      }]);
      if (error) {
        if (error.code === '23505') {
          // Unique constraint violation
          toast({
            title: "Email già registrata",
            description: "Questa email è già stata registrata per la beta.",
            variant: "destructive"
          });
        } else {
          throw error;
        }
      } else {
        toast({
          title: "Richiesta inviata!",
          description: "Ti contatteremo presto con il link per accedere alla beta."
        });
        setUserEmail("");
      }
    } catch (error) {
      console.error('Error submitting user email:', error);
      toast({
        title: "Errore",
        description: "Si è verificato un errore. Riprova più tardi.",
        variant: "destructive"
      });
    } finally {
      setIsSubmittingUser(false);
    }
  };
  const handleCompanySubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmittingCompany(true);
    try {
      const {
        error
      } = await supabase.from('lead_companies').insert([{
        email: companyEmail
      }]);
      if (error) {
        if (error.code === '23505') {
          // Unique constraint violation
          toast({
            title: "Email già registrata",
            description: "Questa email aziendale è già stata registrata.",
            variant: "destructive"
          });
        } else {
          throw error;
        }
      } else {
        toast({
          title: "Richiesta inviata!",
          description: "Ti ricontatteremo presto per discutere le opportunità per la tua azienda."
        });
        setCompanyEmail("");
      }
    } catch (error) {
      console.error('Error submitting company email:', error);
      toast({
        title: "Errore",
        description: "Si è verificato un errore. Riprova più tardi.",
        variant: "destructive"
      });
    } finally {
      setIsSubmittingCompany(false);
    }
  };
  return <div className="py-24 px-6 bg-[#f8faff]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Già 100+ utenti stanno provando Vertigo</h2>
          <p className="text-xl text-secondary max-w-3xl mx-auto">
            Scopri tutte le funzionalità che rivoluzioneranno l'esperienza di assunzione!
          </p>
        </div>
        <div className="flex justify-center gap-8">
          {/* User Form */}
          

          {/* Company Form */}
          <Card className="border-2 border-purple-200 hover:border-purple-300 transition-colors duration-300">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-light text-primary">
                Per Aziende
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-lg text-secondary text-center">
                Sei un'azienda e vuoi scoprire i vantaggi? Ti ricontatteremo via mail
              </p>
              <form onSubmit={handleCompanySubmit} className="space-y-4">
                <Input type="email" placeholder="Email aziendale" value={companyEmail} onChange={e => setCompanyEmail(e.target.value)} required className="text-center" disabled={isSubmittingCompany} />
                <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-white" disabled={isSubmittingCompany}>
                  {isSubmittingCompany ? "Invio in corso..." : "Contattaci"}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
};
export default EmailForms;